// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"198b8b9a","703":"fa3a9b05","787":"4c4bf3c3"}[chunkId] + ".chunk.js";
};